import React from 'react';
import './../styles/card.css';

const UserCard = ({ user }) => {
  if (!user) {
    return null;
  }

  return (
    <div className="card">
      <img src={user.avatar_url} alt={`${user.login} avatar`} width="100" />
      <h2>{user.name || user.login}</h2>
      <p>{user.bio}</p>
      <div>
        <span>Followers: {user.followers}</span>
        <span>Following: {user.following}</span>
        <span>Public Repos: {user.public_repos}</span>
      </div>
      <a href={user.html_url} target="_blank" rel="noopener noreferrer">
        View Profile on GitHub
      </a>
    </div>
  );
};

export default UserCard;
